import { useContext } from "react";
import { Navigate, matchRoutes, useLocation } from "react-router-dom";
import { UserPermissions } from "../constants/enum";
import { extractPermission } from "../helpers/extract";
import UserContext from "../contexts/UserContext";

interface RequiredProps {
  children: JSX.Element;
}

const Protected = ({ children }: RequiredProps) => {
  const {pathname} = useLocation();
  const { user } = useContext(UserContext);
  const permission = extractPermission(user);

  if ((pathname && permission)) {
    
    const role:string = permission.role ? permission.role.toUpperCase() : "NONE";
    const pagePermissionRoutes = role  ? UserPermissions[role.toUpperCase()].map((rt:string)=>({path:rt})) : [];
    const matchedRoutes = matchRoutes(pagePermissionRoutes, pathname);
    
    if(matchedRoutes){
      return children;
    }
    return <Navigate to="/forbidden" replace />;
  }
  return <Navigate to="/forbidden" replace />;
};
export default Protected;
